import React, {Component} from 'react';
import { connect } from 'react-redux';
import {actions} from 'react-redux-form';
import PropTypes from 'prop-types';
import isPlainObject from 'lodash/isPlainObject';
import get from 'lodash/get';
import SearchableSelect from '../../common/form/elements/searchable-select';

class ContactUsSelect extends Component {
  state = {
    selected: null
  };

  createLabel = (item) => {
    const {labelAttr} = this.props;
    const finalLabel = [];
    labelAttr.forEach((label) => {
      finalLabel.push(get(item, label));
    });
    return finalLabel.join(' ');
  };

  renderOptions = (values) => {
    const {valueAttr} = this.props;
    let options = [];
    if (isPlainObject(values)) {
      options = (
        Object.keys(values)
          .map(item => ({
            value: item,
            label: values[item]
          }))
      );
    } else {
      options = (
        values.map((item) => {
          if (isPlainObject(item)) {
            return {
              value: get(item, valueAttr),
              label: this.createLabel(item)
            };
          }
          return {
            value: item,
            label: item
          };
        })
      );
    }
    options.unshift({
      value: '',
      label: 'Select one...'
    });
    return options;
  };

  handleSelectChange = (value) => {
    this.props.dispatch(actions.change(this.props.modal, value));
    this.setState({
      selected: value
    });
  }

  render() {
    const {
      model, values, label
    } = this.props;
    return (
      <SearchableSelect
        label={label}
        model={model}
        options={this.renderOptions(values)}
        value={this.state.selected}
        onChange={value => this.handleSelectChange(value)}
        required
      />
    );
  }
}

ContactUsSelect.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  values: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object]).isRequired,
  labelAttr: PropTypes.array,
  valueAttr: PropTypes.string,
  hasEmptyValue: PropTypes.bool,
  controlId: PropTypes.string,
  errorLabel: PropTypes.string,
};

ContactUsSelect.defaultProps = {
  hasEmptyValue: true,
  labelAttr: 'label',
  valueAttr: 'value',
  controlId: Math.random()
    .toString(16)
    .substring(2),
  errorLabel: 'error',
};

export default connect()(ContactUsSelect);



// WEBPACK FOOTER //
// ./src/components/contact-us/post-login/contact-us-select.jsx